module.exports = __webpack_public_path__ + "static/media/footer-rectangle-1.2e86f223.svg";